/**
 * Slider component.
 */

import './_slider.scss';
import { ApplicationContext } from '../../common/context';
import { Col, Icon, Row } from 'antd';
import React, { useContext, useEffect } from 'react';
import ResultMatriz from '../result/result-matriz';
import SlickEvaluate from './slick-evaluate';
import SlickMatriz from './slick-matriz';
import Swiper from 'swiper/js/swiper.esm.bundle';

let swiper = null;

const Slick = () => {
  const context = useContext(ApplicationContext);
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';
  const forms = context.getOption(`${prefix}.form`);
  const tab = context.tab;

  if (forms.length === 0) {
    context.addColumn(0);
  }

  useEffect(() => {
    swiper = new Swiper('.swiper-container', {
      breakpoints: {
        992: {
          touchRatio: 0
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        clickable: true,
        el: '.swiper-pagination'
      },
      slidesPerView: 'auto',
      spaceBetween: 0

    });

    context.setSwipper(swiper);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.isMatrix, context.isEvaluation]);

  useEffect(() => {
    if (swiper) {
      let swiperClone = swiper;

      if (!Array.isArray(swiperClone)) {
        swiperClone = [swiper];
      }

      swiperClone.forEach(swiper => {
        swiper.update();
      });
    }
  }, [forms]);

  return (
    <div>
      {context.isMatrix ? <Row>
        {tab === '2' ? <div>
          <Col span={24}>
            <div className={'swiper-container'}>
              <div
                className={'swiper-wrapper'}
              >
                {forms.map((form, index) => (
                  <div
                    className={'swiper-slide'}
                    key={form.id}
                  >
                    <SlickMatriz
                      id={index}
                    />
                  </div>))}
              </div>
              <div className={'swiper-wrapper__pagination'}>
                <div className={'swiper-button-prev'}>
                  <Icon type={'arrow-left'} />

                </div>
                <div className={'swiper-pagination'} />
                <div className={'swiper-button-next'}>

                  <Icon type={'arrow-right'} />
                </div>
              </div>
            </div>
          </Col>
        </div> :
          <div>
            <Col span={24}>
              <div className={'swiper-container'}>
                <div
                  className={'swiper-wrapper'}
                >
                  {forms.map((form, index) => (
                    <div
                      className={'swiper-slide'}
                      key={form.id}
                    >
                      <ResultMatriz
                        id={index}
                      />
                    </div>))}
                </div>
                <div className={'swiper-wrapper__pagination'}>
                  <div className={'swiper-button-prev'}>
                    <Icon type={'arrow-left'} />

                  </div>
                  <div className={'swiper-pagination'} />
                  <div className={'swiper-button-next'}>

                    <Icon type={'arrow-right'} />
                  </div>
                </div>
              </div>
            </Col>
          </div>
        }
      </Row> : <Row>
          {tab === '2' ? <div>
            <Col span={24}>
              <div className={'swiper-container swiper-container--evaluation'}>
                <div
                  className={'swiper-wrapper'}
                >
                  {forms.map((form, index) => (
                    <div
                      className={'swiper-slide'}
                      key={form.id}
                    >
                      <SlickEvaluate
                        id={index}
                      />
                    </div>))}
                </div>
                <div className={'swiper-wrapper__pagination'}>
                  <div className={'swiper-button-prev'}>
                    <Icon type={'arrow-left'} />

                  </div>
                  <div className={'swiper-pagination'} />
                  <div className={'swiper-button-next'}>

                    <Icon type={'arrow-right'} />
                  </div>
                </div>
              </div>
            </Col>
          </div> : <div>
              <Col span={24}>
                <div className={'swiper-container'}>
                  <div
                    className={'swiper-wrapper'}
                  />
                  <div className={'swiper-wrapper__pagination'}>
                    <div className={'swiper-button-prev'}>
                      <Icon type={'arrow-left'} />

                    </div>
                    <div className={'swiper-pagination'} />
                    <div className={'swiper-button-next'}>

                      <Icon type={'arrow-right'} />
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          }
        </Row>}
    </div>
  );
};

export default Slick;
